export default __webpack_public_path__ + "static/media/zero.7d5a9a82.png";